<div class="generation-summary">
    <h2>{{ "GenerationDaysSummary.Title" | translate }}</h2>

    @if (summary) {
        <div>
            <div class="success-text">
                <strong>{{ summary.succeed.length }}</strong>
                {{ "GenerationDaysSummary.Success" | translate }}
            </div>
            <div class="warning-text">
                {{ summary.failes.length }}
                {{ "GenerationDaysSummary.Failes" | translate }}
            </div>
            @for (error of getErrors() | groupBy: "code"; track error) {
                <ul>
                    <li>
                        <span>
                            {{ translateError(error.value[0].message) }}
                            {{ "GenerationDaysSummary.ForDays" | translate }}
                        </span>
                        @for (val of error.value; track val) {
                            <span> {{ val.resultParameters[0] }}, </span>
                        }
                    </li>
                </ul>
            }
        </div>
    }
</div>
